export const formatDate = (dateInput?: string) => {
  if (dateInput === null || typeof dateInput === 'undefined') {
    return '';
  } else {
    return new Date(dateInput).toLocaleDateString();
  }
};

export const formatDateTime = (dateTimeInput?: string) => {
  if (dateTimeInput === null || typeof dateTimeInput === 'undefined') {
    return '';
  } else {
    return new Date(dateTimeInput).toLocaleString([], { hour12: true });
  }
};

export const formatDisplayDate = (dateString?: string) => {
  let date = new Date().toLocaleDateString('en-us', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  if (dateString !== undefined) {
    date = new Date(dateString).toLocaleDateString('en-us', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  }

  return date;
};

export const getDateParts = (dateTimeInput?: string) => {
  if (dateTimeInput === null || typeof dateTimeInput === 'undefined') {
    return { day: '', dayName: '', month: '', monthName: '', year: '' };
  } else {
    const dateObj = new Date(dateTimeInput);
    const monthName = dateObj.toLocaleString('default', { month: 'long' });
    const day = dateObj.getDate();
    // Helper to get ordinal suffix
    const getOrdinal = (n: number) => {
      const s = ['th', 'st', 'nd', 'rd'],
        v = n % 100;
      return n + (s[(v - 20) % 10] || s[v] || s[0]);
    };
    const dayName = getOrdinal(day);

    return {
      day: day,
      dayName: dayName,
      monthName: monthName,
      month: dateObj.getMonth() + 1,
      year: dateObj.getFullYear(),
    };
  }
};
